import { render, staticRenderFns } from "./FastCounter.vue?vue&type=template&id=f3a2f328&"
import script from "./FastCounter.vue?vue&type=script&lang=js&"
export * from "./FastCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports